import { useMiniSite } from "../../components/minisite/context";
import { MiniSiteFAQ } from "../RentalProfile";

export default function MiniSiteFAQPage() {
  const { data, theme } = useMiniSite();
  const ms = data.mini_site || {};
  const faqs = ms.faqs || [];

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="ms-faq-page">
      <h1 className="font-display text-3xl sm:text-4xl font-bold" style={{ color: theme }}>
        Frequently asked questions
      </h1>
      {faqs.length === 0 ? (
        <p className="text-slate-500 italic mt-3" data-testid="ms-faq-empty">
          No FAQs published yet. Send the business an inquiry from the Contact or Booking page.
        </p>
      ) : (
        <div className="mt-4">
          <MiniSiteFAQ ms={ms} theme={theme} enabled={true} />
        </div>
      )}
    </div>
  );
}
